export const TIPO_LABORATORIO = "laboratorio";
export const TIPO_LIQUIDACION = "liquidacion";

export const OPCIONES_TIPO_REPORTE = [
    { value: TIPO_LABORATORIO, label: "Laboratorio" },
    { value: TIPO_LIQUIDACION, label: "Liquidación" },
];

// Color de cada versión en las gráficas, el mismo que en las del Excel
export const COLOR_POR_TIPO = {
    [TIPO_LABORATORIO]: "#1976D2",
    [TIPO_LIQUIDACION]: "#ee7401",
};

// Las dos versiones del reporte tienen las mismas columnas. Cambian los títulos
// de las que dependen de la fuente de los kg secos, con los nombres del archivo
// del cliente: Hulerax para laboratorio y liquidado para liquidación
export const TITULOS_POR_TIPO = {
    [TIPO_LABORATORIO]: {
        ingresos: "Ingresos Hulerax (+)",
        enviados: "Kg secos enviados a sólidos Hulerax",
        diferenciaPatios: "Diferencia en patios de ERSA",
        diferenciaTotal: "Diferencia total producción - Hulerax",
        porcentaje: "% de variación entre Hulerax y producción",
        acumuladoUsd: "Acumulado en USD Hulerax vrs producción",
    },
    [TIPO_LIQUIDACION]: {
        ingresos: "Ingresos liquidación (+)",
        enviados: "Kg secos enviados a sólidos liquidados",
        diferenciaPatios: "Diferencia en patios de ERSA liquidado",
        diferenciaTotal: "Diferencia total producción - liquidado",
        porcentaje: "% de variación entre liquidado y producción",
        acumuladoUsd: "Acumulado en USD liquidado vrs producción",
    },
};
